import { RichTextAdvancedRender } from '@framework/engine/inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { type IWidgetComponentProps } from '@framework/engine/schema/widgets/IWidgetType.ts';
import { getWidgetProps } from '@framework/engine/schema/widgets/repository/inputs/common/util/getWidgetProps.ts';
import { ConfigFormItem } from '@framework/engine/ui/form/ConfigFormItem.tsx';
import { currencyNumberFormatter } from '@framework/engine/utils/format/currencyNumberFormatter.ts';
import { ComputedStaticTextInput } from '@framework/form/inputs/computed/ComputedStaticTextInput.tsx';
import { useCallback } from 'react';
import { type IBurdenWidget } from './IBurdenWidget.ts';

export interface IBurdenWidgetComponentProps
  extends IWidgetComponentProps<IBurdenWidget> {}

export function BurdenWidgetComponent(props: IBurdenWidgetComponentProps) {
  const { widget } = props;

  const options = getWidgetProps(props);

  const formatValue = useCallback(
    (value: number | null) =>
      value != null ? currencyNumberFormatter.format(value) : '',
    [],
  );

  return (
    <ConfigFormItem
      hidden={widget.layout?.hide}
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={<RichTextAdvancedRender inline text={options?.helpText} />}
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
      widget={widget}
      required={widget.showVisualAsterisk}
    >
      <ComputedStaticTextInput
        name={options.name}
        removeBorder={widget.layout?.removeBorder}
        format={formatValue}
      />
    </ConfigFormItem>
  );
}
